import AppChrome from '../../components/AppChrome'
import Hero from '../../components/Hero'
import MainContent from '../../components/MainContent'
import SessionChunks from '../../components/SessionChunks'
import PrevNextButtons from '../../components/PrevNextButtons'

export { getServerSideProps } from '../../graphql/session'

function SessionPage( { entry: session, sessions } ) {
  const sessionNumber = session.lft / 2
  const thisSessionIndex = sessions.findIndex( s => s.lft === session.lft )

  const prevSessionUrl = () => {
    if ( thisSessionIndex > -1 && thisSessionIndex > 0 ) {
      return `/course/${ sessions[ thisSessionIndex - 1 ].slug }`
    }

    return null
  }
  
  const nextSessionUrl = () => {
    if ( thisSessionIndex > -1 && thisSessionIndex < sessions.length - 1 ) {
      return `/course/${ sessions[ thisSessionIndex + 1 ].slug }`
    }

    return null
  }

  return (
    <AppChrome color="orange">
      <Hero
        ui={ (
          <PrevNextButtons 
            prevText={ <>Previous<b>&nbsp;session</b></> }
            nextText={ <>Next<b>&nbsp;session</b></> }
            prevHref={ prevSessionUrl() }
            nextHref={ nextSessionUrl() }
          />
        ) }
      >
        <strong>Session { sessionNumber }</strong>
        { session.title }
      </Hero>
      <MainContent 
        contentBlocks={ session.contentBlocks } 
        session={ session }
      />
      <SessionChunks 
        chunks={ session.chunks } 
        sessionId={ session.id }
      />
    </AppChrome>
  )
}

export default SessionPage
